import { InjectionToken, Type } from '@angular/core';

/**
 * The dialog component classes DialogService opens, supplied by the module that already
 * declares them.
 *
 * DialogService used to import each component directly in order to call
 * `this.dialog.open(SomeComponent, ...)`. Many of those components inject DialogService so they
 * can open further dialogs, which made every one of those pairs an import cycle - webpack warned
 * about ~24 of them, and a cycle can leave a class binding undefined at module-evaluation time,
 * so the dialog would fail to open at runtime rather than at compile time.
 *
 * Providing the classes through this token inverts the edge: DialogService imports only the
 * token, and AppModule - which already imports the components in order to declare them, and
 * which nothing imports back - supplies the map.
 *
 * Keys are the class names verbatim, so a lookup greps the same as the old direct reference.
 */
export const DIALOG_COMPONENTS = new InjectionToken<Record<string, Type<any>>>('DIALOG_COMPONENTS');
